// Which board the boat's home shows (TOM-510, cloud ADR 0335): always the
// mode's board (TOM-526). At Anchor while anchored or while an anchor watch is
// on, Underway while underway, At dock while docked (modeBoards.ts). Other
// boards open from the rail's and the sidebar's boards; home has no board menu
// and keeps no pick (TOM-510's `nm.homeBoard.*` key is no longer read).
//
// Pure.

import type { OverviewArchetype } from '@neomaris/protocol';

import type { NeoBoardSummary } from './neoBoards';
import { modeBoardKey, redirectKey, systemBoardFor } from './modeBoards';

/** What home knows about the boat's mode right now. */
export interface HomeMode {
  /** The cloud's fold of the boat's mode, null when it can't tell. */
  archetype: OverviewArchetype | null;
  anchorWatchOn: boolean;
}

/** The mode board's key home follows: null while the boat's mode is unknown. */
export function homeModeKey(mode: HomeMode): OverviewArchetype | null {
  return modeBoardKey(mode.archetype, mode.anchorWatchOn);
}

/**
 * The board home shows: the mode's board, At Anchor while the mode is unknown
 * (as `instruments` leads there), then the first system board.
 */
export function homeBoard(
  systemBoards: readonly NeoBoardSummary[],
  mode: HomeMode
): NeoBoardSummary | null {
  return (
    systemBoardFor(systemBoards, homeModeKey(mode)) ??
    systemBoardFor(systemBoards, redirectKey(null)) ??
    systemBoards[0] ??
    null
  );
}
